/** A failed asset list request that keeps its HTTP status (e.g. 401 once the session expired). */
export class AssetListHttpError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'AssetListHttpError';
  }
}

/** True for a 401: the authToken cookie has expired, retrying or polling cannot succeed. */
export function isUnauthorizedError(error: unknown): boolean {
  return error instanceof AssetListHttpError && error.status === 401;
}
